import type { Dialog } from '@syncfusion/ej2-popups';
import { DIALOG_ID } from './scheduleCommon';

export async function scheduleDialog(self: any, peopleList: any[], width: string = '600px') {

    await import('@syncfusion/ej2-base/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-icons/styles/bootstrap5.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap5.3.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap5.3.css');

    await import('../loadSyncfusion');

    const { Dialog } = await import('@syncfusion/ej2-popups');

    const dialogContainer = document.querySelector("#"+DIALOG_ID) as HTMLElement;

    if (dialogContainer === null || dialogContainer.hasAttribute("data-dialogpopup")) {
        return;
    }

    dialogContainer.setAttribute('data-dialogpopup', 'true');
    // Initialize Dialog component
    let dialog = new Dialog({
            // // Enables the header with template content
            // header: '</>', //document.getElementById("dlgHeader"),
            // // Enables the footer with template content
            // footerTemplate: '</>',
        // Dialog content
        content: document.getElementById('custom-dialog-template'),
        // Enables the close icon button in header
        showCloseIcon: true,
        close: function () {
            document.getElementById("dlgContent").innerHTML = ''
        },
        // The Dialog shows within the target element
        target: document.getElementById("create-dialog-container"),
        //Dialog width
        //width: 'auto',
        //height: '600px',
        // beforeOpen: onBeforeopen,
        isModal: true,
        visible: false,
        position: {
            X: 'center',
            Y: 'top'
        }
    });
    // Render initialized Dialog
    dialog.appendTo('#'+DIALOG_ID);
}